export enum ApiStatus {
  Initial = 'initial',
  Connecting = 'connecting',
  Refreshing = 'refreshing',
  Success = 'success',
  ValidationError = 'validationError',
  ConnectionError = 'connectionError',
  ServerError = 'serverError',
  ValidationErrorOnRefresh = 'validationErrorOnRefresh',
  ConnectionErrorOnRefresh = 'connectionErrorOnRefresh',
  ServerErrorOnRefresh = 'serverErrorOnRefresh',
}
